import { ModelDataType } from 'src/app/interfaces/model-data-type';
import { ZendeskTicketFormContent } from 'src/app/interfaces/zendesk-ticket-form-content';

import { BaseModel } from './base-model';

export class ZendeskTicketForm extends BaseModel {
  static override columnMap = new Map<
    string,
    { property: string; type: 'column'; dataType: ModelDataType }
  >();
  static override associationMap = new Map<
    string,
    { property: string; type: 'association'; model: string }
  >();
  static override aliasedColumnMap = new Map<
    string,
    { property: string; type: 'alias' }
  >();

  static ZendeskTicketFormProperties: (
    | {
        property: keyof ZendeskTicketForm;
        type: 'column';
        dataType: ModelDataType;
      }
    | {
        property: keyof ZendeskTicketForm;
        type: 'alias';
      }
    | {
        property: keyof ZendeskTicketForm;
        type: 'association';
        model: string;
      }
  )[] = [
    { property: 'id', type: 'column', dataType: 'number' },
    { property: 'ZendeskTicketFormId', type: 'column', dataType: 'number' },
    { property: 'ticketFormContentJSON', type: 'column', dataType: 'JSON' },
    { property: 'active', type: 'column', dataType: 'boolean' },
    { property: 'createdAt', type: 'column', dataType: 'date' },
    { property: 'updatedAt', type: 'column', dataType: 'date' }
  ];

  static {
    ZendeskTicketForm.ZendeskTicketFormProperties.forEach((propertyObject) => {
      const { property, type } = propertyObject;
      if (type === 'column') {
        ZendeskTicketForm.columnMap.set(property, propertyObject);
      }
      if (type === 'alias') {
        ZendeskTicketForm.aliasedColumnMap.set(
          property,
          propertyObject as { property: string; type: 'alias' }
        );
      }
      if (type === 'association') {
        ZendeskTicketForm.associationMap.set(
          property,
          propertyObject as {
            property: string;
            type: 'association';
            model: string;
          }
        );
      }
    });
  }

  constructor(ZendeskTicketFormObject: Partial<ZendeskTicketForm>) {
    super();

    ZendeskTicketForm.ZendeskTicketFormProperties.forEach((propertyObject) => {
      const { property } = propertyObject;
      const value = ZendeskTicketFormObject[property];
      if (value !== undefined) {
        Object.assign(this, { [property]: value });
      }
    });
  }

  id?: number;
  ZendeskTicketFormId?: string;
  ticketFormContentJSON?: ZendeskTicketFormContent;
  active?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
}
